module.exports = __webpack_public_path__ + "static/eastleigh-778617cdfe42d32628a55cb60b9e2d44.png";